import { render, staticRenderFns } from "./base-dialog.vue?vue&type=template&id=ddfacac4&scoped=true&"
import script from "./base-dialog.vue?vue&type=script&lang=js&"
export * from "./base-dialog.vue?vue&type=script&lang=js&"
import style0 from "./base-dialog.vue?vue&type=style&index=0&id=ddfacac4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddfacac4",
  null
  
)

export default component.exports